import React, { useEffect, useState } from 'react';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';
import 'line-awesome/dist/line-awesome/css/line-awesome.min.css';
import { Helmet } from 'react-helmet';
import api from '../../services/api';

const Pricing = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const { data } = await api.get('/plans');
        setPlans(data.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to load plans');
        setLoading(false);
      }
    };
    fetchPlans();
  }, []);

  // Group plans by plan_type
  const groupPlansByType = (plans) => {
    return plans.reduce((acc, plan) => {
      if (!acc[plan.plan_type]) {
        acc[plan.plan_type] = [];
      }
      acc[plan.plan_type].push(plan);
      return acc;
    }, {});
  };

  const groupedPlans = groupPlansByType(plans);

  if (loading) {
    return (
      <div className="home-page">
        <Helmet><title>Loading Plans...</title></Helmet>
        <Navbar />
        <div className="container text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  if (error) {
    return (
      <div className="home-page">
        <Helmet><title>Error Loading Plans</title></Helmet>
        <Navbar />
        <div className="container text-center py-5">
          <div className="alert alert-danger">{error}</div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="home-page">
      <Helmet>
        <title>Our Plans - startupbusinesspartners</title>
      </Helmet>
      
      <Navbar />

      <section className="breadcrumb_area breadcrumb1">
        <div className="container mt-2">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcrumb_wrapper d-flex align-items-center justify-content-between flex-wrap">
                <h4 className="page_title">Our Plans</h4>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a href="#">Home</a></li>
                    <li className="breadcrumb-item active" aria-current="page">Plans</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container">
        {/* Render grouped plans by type */}
        {Object.entries(groupedPlans).map(([planType, planList]) => (
          <div key={planType} className="plan-type-section mb-5">
            <h3 className="text-center my-4 text-uppercase border-bottom pb-2">
       
                    {planType === "Business"
        ? "Business for Sell"
        : planType === "Employee"
        ? "Skilled Business Employee"
        : planType}{" "}
   
            </h3>

            <div className="row mt-4">
              {planList.map((plan) => (
                <div className="col-lg-4 col-md-6 mb-4" key={plan.id}>
                  <div className={`pricing pricing--1 shadow-lg-2 ${plan.status === 'active' ? 'active-plan' : 'inactive-plan'}`}>
                    <div className="pricing__title">
                      <h4>{plan.plan_name}</h4>
                      <span>{plan.tagline || 'Premium Solution'}</span>
                      {plan.status !== 'active' && (
                        <span className="badge bg-secondary ms-2">Expired</span>
                      )}
                    </div>

                    <div className="pricing__price rounded">
                      <p>
                        <sup>₹</sup>
                        {parseFloat(plan.price).toFixed(2)}
                        <small>/month</small>
                      </p>
                    </div>

                    <div className="pricing__features">
                      <ul>
                        {plan.features?.split(',').map((feature, index) => (
                          <li key={index}>{feature.trim()}</li>
                        ))}
                      </ul>
                    </div>

                    <p>{plan.content || 'No description available.'}</p>

                    <a 
                      href="/register" 
                      className={`btn ${plan.status === 'active' ? 'btn-outline-secondary' : 'btn-outline-secondary disabled'}`}
                    >
                      {plan.status === 'active' ? 'Purchase' : 'Unavailable'}
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Optional CTA Section */}
      <section className="cta-wrapper cta--eight gradient-overlay mt-5"> 
        <div className="container content_above">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 text-center">
              <h1 className="color-light m-bottom-50">Need a custom solution for your business?</h1>
              <a href="/contact" className="btn btn-warning">Contact Us</a> 
            </div>
          </div>
        </div>
      </section>

      <Footer />

      <style jsx>{`
        .pricing.active-plan {
          border-top: 4px solid #4eac6d;
        }
        .pricing.inactive-plan {
          opacity: 0.8;
          filter: grayscale(20%);
        }
        .pricing__price {
          background-color: #f8f9fa;
          padding: 1.5rem;
          margin: 1rem 0;
        }
        .pricing__price p {
          font-size: 2.5rem;
          font-weight: 700;
          margin: 0;
        }
        .pricing__price p sup {
          font-size: 1rem;
          top: -1.2em;
        }
        .pricing__price p small {
          font-size: 1rem;
          font-weight: 400;
        }
        .pricing__features ul {
          padding-left: 0;
          list-style: none;
        }
        .pricing__features li {
          padding: 0.5rem 0;
          border-bottom: 1px solid #eee;
        }
        .gradient-overlay {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          padding: 4rem 0;
          color: white;
        }
        .plan-type-section h3 {
          font-weight: 700;
          letter-spacing: 1px;
          color: #333;
        }
      `}</style>
    </div>
  );
};

export default Pricing;
